
// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

﻿import API_BASE from "../config.js";
import React, { useState, useRef, useEffect } from "react";
import { getLimitePlano, getPlanoAtual } from "../services/planLimits";
import Layout from "../components/Layout";
import { Dica, BotaoDica } from "../components/Dica";
import Modal from "../components/Modal";
import { useTranslation } from "react-i18next";
import { authFetch } from "../services/authFetch";
import useEstoqueRadar from "../hooks/useEstoqueRadar";

// Backend usa "preco_custo"; a tela usa "custo" internamente.
function daApi(row) {
  return { ...row, custo: Number(row.preco_custo) || 0 };
}
function paraApi(item) {
  return { id: item.id, nome: item.nome, categoria: item.categoria, quantidade: item.quantidade,
    preco: item.preco, preco_custo: Number(item.custo) || 0, unidade: item.unidade, minimo: item.minimo };
}

const CATEGORIAS = ["Oleo e Fluidos", "Freios", "Filtros", "Suspensao", "Eletrica", "Motor", "Outros"];

const ESTOQUE_MOCK = [
  { id: 1, nome: "Oleo 5W-30 1L",       categoria: "Oleo e Fluidos", quantidade: 5,  minimo: 10, preco: 28.90,  custo: 18.00, unidade: "lt", codigo: "OL001", foto: "" },
  { id: 2, nome: "Filtro de Oleo",       categoria: "Filtros",        quantidade: 3,  minimo: 5,  preco: 35.00,  custo: 20.00, unidade: "un", codigo: "FT001", foto: "" },
  { id: 3, nome: "Pastilha de Freio",    categoria: "Freios",         quantidade: 2,  minimo: 4,  preco: 89.90,  custo: 55.00, unidade: "jg", codigo: "FR001", foto: "" },
  { id: 4, nome: "Filtro de Ar",         categoria: "Filtros",        quantidade: 8,  minimo: 5,  preco: 42.00,  custo: 25.00, unidade: "un", codigo: "FT002", foto: "" },
  { id: 5, nome: "Vela de Ignicao",      categoria: "Motor",          quantidade: 12, minimo: 8,  preco: 18.50,  custo: 10.00, unidade: "un", codigo: "MT001", foto: "" },
  { id: 6, nome: "Correia Dentada",      categoria: "Motor",          quantidade: 4,  minimo: 3,  preco: 125.00, custo: 80.00, unidade: "un", codigo: "MT002", foto: "" },
  { id: 7, nome: "Fluido de Freio DOT4", categoria: "Freios",         quantidade: 6,  minimo: 4,  preco: 22.00,  custo: 12.00, unidade: "lt", codigo: "FR002", foto: "" },
  { id: 8, nome: "Amortecedor Diant.",   categoria: "Suspensao",      quantidade: 2,  minimo: 2,  preco: 320.00, custo: 200.00,unidade: "un", codigo: "SU001", foto: "" },
];

function calcMargem(custo, preco) {
  const c = Number(custo) || 0;
  const p = Number(preco) || 0;
  if (!c || !p || p <= 0) return { lucroUnit: 0, margem: 0 };
  const lucroUnit = p - c;
  const margem = (lucroUnit / p) * 100;
  return { lucroUnit, margem };
}

function BtnFechar({ onClick }) {
  return <button onClick={onClick} style={{ background:"var(--bg4)", border:"none", borderRadius:8, color:"var(--text2)", cursor:"pointer", fontSize:20, lineHeight:1, padding:"4px 10px" }}>x</button>;
}

function CalculadorPreco({ custo, preco, onPrecoSugerido }) {
  const { t } = useTranslation();
  const [margemDesejada, setMargemDesejada] = useState(30);
  const c = Number(custo) || 0;
  const p = Number(preco) || 0;
  const precoSugerido = c > 0 ? c / (1 - margemDesejada / 100) : 0;
  const { lucroUnit, margem: margemAtual } = calcMargem(c, p);
  if (!c) return (
    <div style={{ background:"var(--bg4)", borderRadius:8, color:"var(--text3)", fontSize:12, padding:"10px 14px", textAlign:"center" }}>
      {t("estoque.calc_preencha_custo")}
    </div>
  );
  return (
    <div style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:10, padding:14 }}>
      <div style={{ color:"var(--text2)", fontSize:11, fontWeight:700, letterSpacing:"0.06em", marginBottom:10, textTransform:"uppercase" }}>{t("estoque.calc_titulo")}</div>
      <div style={{ display:"grid", gap:8, gridTemplateColumns:"1fr 1fr 1fr", marginBottom:12 }}>
        <div style={{ background:"var(--bg4)", borderRadius:8, padding:"8px 10px", textAlign:"center" }}>
          <div style={{ color:"var(--text3)", fontSize:10, marginBottom:3 }}>{t("estoque.calc_custo")}</div>
          <div style={{ color:"#f97316", fontSize:15, fontWeight:700 }}>R$ {c.toFixed(2)}</div>
        </div>
        <div style={{ background:"var(--bg4)", borderRadius:8, padding:"8px 10px", textAlign:"center" }}>
          <div style={{ color:"var(--text3)", fontSize:10, marginBottom:3 }}>{t("estoque.calc_lucro_unit")}</div>
          <div style={{ color:lucroUnit >= 0 ? "#22c55e" : "#ef4444", fontSize:15, fontWeight:700 }}>R$ {lucroUnit.toFixed(2)}</div>
        </div>
        <div style={{ background:"var(--bg4)", borderRadius:8, padding:"8px 10px", textAlign:"center" }}>
          <div style={{ color:"var(--text3)", fontSize:10, marginBottom:3 }}>{t("estoque.calc_margem_atual")}</div>
          <div style={{ color:margemAtual >= 20 ? "#22c55e" : margemAtual >= 10 ? "#f97316" : "#ef4444", fontSize:15, fontWeight:700 }}>{margemAtual.toFixed(1)}%</div>
        </div>
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
        <div style={{ color:"var(--text2)", fontSize:12, flexShrink:0 }}>{t("estoque.calc_margem_desejada")}</div>
        <input type="range" min={1} max={90} value={margemDesejada} onChange={e => setMargemDesejada(Number(e.target.value))} style={{ flex:1, accentColor:"var(--accent)" }} />
        <div style={{ background:"var(--accent)22", borderRadius:6, color:"var(--accent)", fontSize:13, fontWeight:700, minWidth:42, padding:"3px 8px", textAlign:"center" }}>{margemDesejada}%</div>
      </div>
      {precoSugerido > 0 && (
        <div style={{ alignItems:"center", background:"#22c55e15", border:"1px solid #22c55e44", borderRadius:8, display:"flex", gap:10, justifyContent:"space-between", padding:"10px 12px" }}>
          <div>
            <div style={{ color:"var(--text3)", fontSize:11 }}>{t("estoque.calc_preco_sugerido_para",{margem:margemDesejada})}</div>
            <div style={{ color:"#22c55e", fontSize:18, fontWeight:800 }}>R$ {precoSugerido.toFixed(2)}</div>
          </div>
          <button onClick={() => onPrecoSugerido(precoSugerido.toFixed(2))} style={{ background:"#22c55e", border:"none", borderRadius:7, color:"#fff", cursor:"pointer", fontSize:12, fontWeight:700, padding:"8px 14px", whiteSpace:"nowrap" }}>
            {t("estoque.calc_usar_preco")}
          </button>
        </div>
      )}
    </div>
  );
}

function ModalBuscaExterna({ onClose, estoqueAtual, onImportar }) {
  const { t } = useTranslation();
  const [busca, setBusca] = useState("");
  const [resultados, setResultados] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [msgDuplicata, setMsgDuplicata] = useState(null);
  const [importado, setImportado] = useState({});
  const timerRef = useRef(null);

  const buscarProdutos = async (texto) => {
    if (texto.length < 2) { setResultados([]); return; }
    setCarregando(true); setMsgDuplicata(null);
    try {
      // AUD-003: era `fetch` puro, sem token -- e por isso /busca/produtos
      // precisava ficar publica. Ela e um proxy para a API do Gemini com a
      // NOSSA chave: aberta, qualquer um na internet consome a cota.
      // authFetch ja e usado em todo o resto deste arquivo (linhas 304, 330,
      // 337) e ainda renova o token sozinho se vier 401.
      const res = await authFetch(API_BASE + "/api/v1/busca/produtos?q=" + encodeURIComponent(texto));
      if (res.ok) { const data = await res.json(); setResultados(data); } else setResultados([]);
    } catch { setResultados([]); } finally { setCarregando(false); }
  };

  const handleBusca = (e) => {
    const v = e.target.value; setBusca(v);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => buscarProdutos(v), 700);
  };

  const handleImportar = (produto) => {
    const jaExiste = estoqueAtual.find(i => i.nome.toLowerCase().trim() === produto.nome.toLowerCase().trim() || (i.codigo && produto.codigo && i.codigo.toLowerCase() === produto.codigo.toLowerCase()));
    if (jaExiste) { setMsgDuplicata({ produto, existente: jaExiste }); return; }
    onImportar(produto);
    setImportado(prev => ({ ...prev, [produto.nome]: true }));
  };

  return (
    <Modal onClose={onClose} largura={780}>
      <div style={{ alignItems:"center", display:"flex", justifyContent:"space-between", marginBottom:20 }}>
        <div>
          <h2 style={{ fontSize:18, fontWeight:700 }}>{t("estoque.busca_ext_titulo")}</h2>
          <p style={{ color:"var(--accent2)", fontSize:12, marginTop:4 }}>{t("estoque.busca_ext_subtitulo")}</p>
        </div>
        <BtnFechar onClick={onClose} />
      </div>
      <div style={{ marginBottom:20 }}>
        <input value={busca} onChange={handleBusca} placeholder={t("estoque.busca_ext_placeholder")} style={{ fontSize:15, padding:"12px 16px", width:"100%" }} autoFocus />
        {carregando && (
          <div style={{ alignItems:"center", background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:8, color:"var(--accent2)", display:"flex", fontSize:13, gap:8, justifyContent:"center", marginTop:12, padding:16 }}>
            <div style={{ animation:"spin 1s linear infinite", border:"2px solid var(--border)", borderRadius:"50%", borderTop:"2px solid var(--accent)", height:16, width:16 }} />
            {t("estoque.busca_ext_buscando")}
          </div>
        )}
      </div>
      {msgDuplicata && (
        <div style={{ background:"#f59e0b15", border:"1px solid #f59e0b60", borderRadius:10, marginBottom:16, padding:16 }}>
          <div style={{ color:"#fbbf24", fontWeight:700, marginBottom:8 }}>{t("estoque.busca_ext_ja_existe")}</div>
          <div style={{ color:"var(--text2)", fontSize:13, marginBottom:12 }}>
            <strong>{msgDuplicata.existente.nome}</strong> {t("estoque.busca_ext_ja_cadastrado",{atual:msgDuplicata.existente.preco.toFixed(2), encontrado:Number(msgDuplicata.produto.preco).toFixed(2)})}
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button className="btn-ghost" style={{ fontSize:12 }} onClick={() => setMsgDuplicata(null)}>{t("common.cancelar")}</button>
            <button style={{ background:"#f59e0b", border:"none", borderRadius:8, color:"#000", cursor:"pointer", fontFamily:"inherit", fontSize:12, fontWeight:700, padding:"8px 16px" }}
              onClick={() => { onImportar(msgDuplicata.produto, true); setMsgDuplicata(null); setImportado(prev => ({ ...prev, [msgDuplicata.produto.nome]: true })); }}>
              {t("estoque.busca_ext_atualizar_preco")}
            </button>
          </div>
        </div>
      )}
      {resultados.length > 0 && (
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          <div style={{ color:"var(--text2)", fontSize:12, marginBottom:4 }}>{t("estoque.busca_ext_produtos_encontrados",{count:resultados.length})}</div>
          {resultados.map((p, i) => {
            const jaImportado = importado[p.nome];
            const jaNoEstoque = estoqueAtual.find(item => item.nome.toLowerCase().trim() === p.nome.toLowerCase().trim());
            return (
              <div key={i} style={{ alignItems:"flex-start", background:jaImportado?"#22c55e10":"var(--bg3)", border:"1px solid "+(jaImportado?"#22c55e40":"var(--border)"), borderRadius:10, display:"flex", gap:14, justifyContent:"space-between", padding:14 }}>
                <div style={{ flex:1 }}>
                  <div style={{ alignItems:"center", display:"flex", flexWrap:"wrap", gap:8, marginBottom:6 }}>
                    <span style={{ fontWeight:700 }}>{p.nome}</span>
                    {p.marca && <span style={{ background:"var(--accent)22", borderRadius:4, color:"var(--accent2)", fontSize:11, fontWeight:600, padding:"1px 7px" }}>{p.marca}</span>}
                    {jaNoEstoque && <span style={{ background:"#f59e0b22", borderRadius:4, color:"#fbbf24", fontSize:10, fontWeight:600, padding:"1px 7px" }}>{t("estoque.busca_ext_ja_no_estoque")}</span>}
                  </div>
                  {p.descricao && <div style={{ color:"var(--text2)", fontSize:12, marginBottom:4 }}>{p.descricao}</div>}
                  {p.compatibilidade && <div style={{ color:"var(--text3)", fontSize:11 }}>{p.compatibilidade}</div>}
                  <div style={{ alignItems:"center", display:"flex", gap:10, marginTop:8 }}>
                    <span style={{ background:"var(--bg4)", borderRadius:4, color:"var(--text2)", fontSize:10, padding:"1px 7px" }}>{p.categoria}</span>
                    {p.codigo && <span style={{ color:"var(--text3)", fontFamily:"monospace", fontSize:10 }}>{p.codigo}</span>}
                  </div>
                </div>
                <div style={{ alignItems:"flex-end", display:"flex", flexDirection:"column", gap:8, flexShrink:0 }}>
                  <div style={{ color:"var(--green)", fontSize:18, fontWeight:800 }}>R$ {Number(p.preco).toFixed(2)}</div>
                  {jaImportado
                    ? <div style={{ background:"#22c55e22", borderRadius:8, color:"#4ade80", fontSize:12, fontWeight:600, padding:"6px 12px" }}>{t("estoque.busca_ext_adicionado")}</div>
                    : <button className="btn-primary" style={{ fontSize:12, padding:"8px 14px" }} onClick={() => handleImportar(p)}>{t("estoque.busca_ext_adicionar")}</button>}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {!carregando && busca.length >= 2 && resultados.length === 0 && <div style={{ color:"var(--text2)", padding:32, textAlign:"center" }}>{t("estoque.busca_ext_nenhum_resultado")}</div>}
      {busca.length === 0 && <div style={{ color:"var(--text3)", fontSize:13, padding:"20px 0", textAlign:"center" }}>{t("estoque.busca_ext_digite_2")}</div>}
    </Modal>
  );
}

// P8 (documento de evolucao, Fase 0 -> Fase 1): compara quantidade em maos
// com consumo medio recente (saidas reais registradas em
// estoque_movimentacoes). So busca dado via useEstoqueRadar -- todo o
// calculo de "abaixo do minimo" ja vem pronto do backend, este componente
// so decide como mostrar. Sem numero inventado: quando nao ha movimentacao
// registrada pro item, mostra "sem dado de consumo" em vez de uma taxa.
function ModalRadarEstoque({ onClose, tenantId }) {
  const { t } = useTranslation();
  const { status, itens } = useEstoqueRadar(tenantId, { ativo: true });

  const ordenados = [...itens].sort((a, b) => {
    if (a.abaixo_minimo !== b.abaixo_minimo) return a.abaixo_minimo ? -1 : 1;
    return (a.quantidade - a.minimo) - (b.quantidade - b.minimo);
  });

  return (
    <Modal onClose={onClose} largura={720}>
      <div style={{ alignItems:"center", display:"flex", justifyContent:"space-between", marginBottom:8 }}>
        <div>
          <h2 style={{ fontSize:18, fontWeight:700 }}>{t("estoque.radar_titulo")}</h2>
          <p style={{ color:"var(--accent2)", fontSize:12, marginTop:4 }}>{t("estoque.radar_subtitulo")}</p>
        </div>
        <BtnFechar onClick={onClose} />
      </div>
      <div style={{ color:"var(--text3)", fontSize:11, marginBottom:16 }}>{t("estoque.radar_os_indisponivel")}</div>

      {status === "loading" && (
        <div style={{ alignItems:"center", background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:8, color:"var(--accent2)", display:"flex", fontSize:13, gap:8, justifyContent:"center", padding:20 }}>
          <div style={{ animation:"spin 1s linear infinite", border:"2px solid var(--border)", borderRadius:"50%", borderTop:"2px solid var(--accent)", height:16, width:16 }} />
          {t("estoque.radar_carregando")}
        </div>
      )}

      {status === "erro" && (
        <div style={{ background:"#ef444415", border:"1px solid #ef444460", borderRadius:8, color:"#ef4444", fontSize:13, padding:16, textAlign:"center" }}>
          {t("estoque.radar_erro")}
        </div>
      )}

      {status === "pronto" && ordenados.length === 0 && (
        <div style={{ color:"var(--text2)", padding:32, textAlign:"center" }}>{t("estoque.radar_vazio")}</div>
      )}

      {status === "pronto" && ordenados.length > 0 && (
        <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
          {ordenados.map((item) => (
            <div key={item.id} style={{ alignItems:"center", background:item.abaixo_minimo?"#f9731610":"var(--bg3)", border:"1px solid "+(item.abaixo_minimo?"#f9731650":"var(--border)"), borderRadius:10, display:"flex", gap:14, justifyContent:"space-between", padding:"12px 14px" }}>
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:700, marginBottom:4 }}>{item.nome}</div>
                <div style={{ color:"var(--text2)", fontSize:12 }}>
                  {item.quantidade} {item.unidade} {t("estoque.col_min").toLowerCase()} {item.minimo}
                </div>
                <div style={{ color:"var(--text3)", fontSize:11, marginTop:4 }}>
                  {item.sem_dado_consumo
                    ? t("estoque.radar_sem_dado_consumo")
                    : t("estoque.radar_consumo_medio_dia", { valor: item.consumo_medio_diario, dias: item.periodo_dias })}
                </div>
              </div>
              <span style={{ background:item.abaixo_minimo?"#f9731622":"#22c55e22", borderRadius:20, color:item.abaixo_minimo?"#f97316":"#22c55e", flexShrink:0, fontSize:11, fontWeight:600, padding:"4px 10px", whiteSpace:"nowrap" }}>
                {item.abaixo_minimo ? t("estoque.radar_abaixo_minimo") : t("estoque.radar_ok")}
              </span>
            </div>
          ))}
        </div>
      )}
    </Modal>
  );
}

export default function Estoque() {
  const { t } = useTranslation();
  const tenantId = getTenantIdFromToken() || "1";
  const STORAGE_KEY = "estoque_tenant_" + tenantId;

  const [itens, setItens] = useState(() => {
    try { const s = localStorage.getItem(STORAGE_KEY); return s ? JSON.parse(s) : ESTOQUE_MOCK; } catch { return ESTOQUE_MOCK; }
  });
  const [busca, setBusca] = useState("");
  const [categoria, setCategoria] = useState("Todas");
  const [modalNovo, setModalNovo] = useState(false);
  const [modalEditar, setModalEditar] = useState(null);
  const [modalMovimento, setModalMovimento] = useState(null);
  const [modalBusca, setModalBusca] = useState(false);
  const [modalRadar, setModalRadar] = useState(false);
  const [form, setForm] = useState({ nome:"", categoria:"Filtros", quantidade:"", minimo:"", preco:"", custo:"", unidade:"un", codigo:"", foto:"" });
  const [tipoMov, setTipoMov] = useState("entrada");
  const [qtdMov, setQtdMov] = useState("");

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(itens)); } catch {}
  }, [itens, STORAGE_KEY]);

  // Carrega do banco (fonte de verdade). O banco nao guarda codigo/foto ainda,
  // entao mesclamos esses dois campos com o que ja estava no cache local, por id.
  useEffect(() => {
    let cacheAntigo = [];
    try { cacheAntigo = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch {}
    authFetch(API_BASE + "/api/v1/dados/estoque/" + tenantId, {})
      .then(r => r.ok ? r.json() : null)
      .then(dados => {
        if (!Array.isArray(dados)) return;
        const porId = Object.fromEntries(cacheAntigo.map(i => [i.id, i]));
        setItens(dados.map(row => {
          const conv = daApi(row);
          const antigo = porId[conv.id];
          return { ...conv, codigo: antigo?.codigo || "", foto: antigo?.foto || "" };
        }));
      })
      .catch(() => {});
  }, [tenantId, STORAGE_KEY]);

  useEffect(() => {
    try {
      const valorTotal = itens.reduce((a, i) => a + i.quantidade * i.preco, 0);
      const lucroTotal = itens.reduce((a, i) => { const { lucroUnit } = calcMargem(i.custo, i.preco); return a + lucroUnit * i.quantidade; }, 0);
      const comCusto = itens.filter(i => i.custo > 0);
      const margemMedia = comCusto.length ? comCusto.reduce((a, i) => a + calcMargem(i.custo, i.preco).margem, 0) / comCusto.length : 0;
      localStorage.setItem("estoque_resumo_tenant_" + tenantId, JSON.stringify({ valorTotal, lucroTotal, margemMedia, totalItens: itens.length, estoqueBaixo: itens.filter(i => i.quantidade <= i.minimo).length, atualizadoEm: Date.now() }));
    } catch {}
  }, [itens, tenantId]);

  const apiSalvarItem = async (item) => {
    try {
      const r = await authFetch(API_BASE + "/api/v1/dados/estoque/" + tenantId, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify(paraApi(item)) });
      if (r.ok) return r.json();
    } catch {}
    return null;
  };

  const apiExcluirItem = async (id) => {
    try { await authFetch(API_BASE + "/api/v1/dados/estoque/" + tenantId + "/" + id, { method:"DELETE" }); } catch {}
  };

  const excluirItem = (item) => {
    if (!window.confirm("Excluir \"" + item.nome + "\" do estoque?")) return;
    setItens(l => l.filter(i => i.id !== item.id));
    apiExcluirItem(item.id);
  };

  const atualizar = (c, v) => setForm(f => ({ ...f, [c]: v }));

  const salvar = async () => {
    if (!form.nome || !form.quantidade) return;
    const base = { ...form, quantidade:Number(form.quantidade), minimo:Number(form.minimo), preco:Number(form.preco), custo:Number(form.custo)||0 };
    if (modalEditar) {
      const atualizado = { ...modalEditar, ...base, id: modalEditar.id };
      setItens(l => l.map(i => i.id === modalEditar.id ? atualizado : i));
      setModalEditar(null);
      apiSalvarItem(atualizado);
    } else {
      const novo = { ...base };
      apiSalvarItem(novo).then(res => {
        const id = res && res.id ? res.id : Date.now();
        setItens(l => [...l, { ...novo, id }]);
      });
      setModalNovo(false);
    }
    setForm({ nome:"", categoria:"Filtros", quantidade:"", minimo:"", preco:"", custo:"", unidade:"un", codigo:"", foto:"" });
  };

  const importarProduto = (produto, atualizar_preco = false) => {
    if (atualizar_preco) {
      setItens(l => {
        const nova = l.map(i => i.nome.toLowerCase().trim() === produto.nome.toLowerCase().trim() ? { ...i, preco:Number(produto.preco) } : i);
        const alterado = nova.find(i => i.nome.toLowerCase().trim() === produto.nome.toLowerCase().trim());
        if (alterado) apiSalvarItem(alterado);
        return nova;
      });
      return;
    }
    const novoImport = { nome:produto.nome, categoria:produto.categoria||"Outros", quantidade:0, minimo:2, preco:Number(produto.preco), custo:0, unidade:produto.unidade||"un", codigo:produto.codigo||"", foto:"" };
    apiSalvarItem(novoImport).then(res => {
      if (res && res.id) setItens(l => [...l, { ...novoImport, id:res.id }]);
      else setItens(l => [...l, { ...novoImport, id:Date.now() }]);
    });
  };

  const registrarMovimento = () => {
    const q = Number(qtdMov); if (!q || q <= 0) return;
    let atualizado = null;
    setItens(l => l.map(i => {
      if (i.id !== modalMovimento.id) return i;
      atualizado = { ...i, quantidade:tipoMov==="entrada"?i.quantidade+q:Math.max(0,i.quantidade-q) };
      return atualizado;
    }));
    if (atualizado) apiSalvarItem(atualizado);
    setQtdMov(""); setModalMovimento(null);
  };

  const filtrados = itens.filter(i => (categoria==="Todas"||i.categoria===categoria) && (!busca||i.nome.toLowerCase().includes(busca.toLowerCase())||(i.codigo||"").toLowerCase().includes(busca.toLowerCase())));
  const totalItens = itens.length;
  const estoqueBaixo = itens.filter(i => i.quantidade <= i.minimo).length;
  const valorTotal = itens.reduce((a, i) => a + i.quantidade * i.preco, 0);
  const lucroTotal = itens.reduce((a, i) => { const { lucroUnit } = calcMargem(i.custo, i.preco); return a + lucroUnit * i.quantidade; }, 0);

  const statusEstoque = (item) => {
    // 02/09/2026 (pedido do Abima) -- estoque agora pode ficar negativo (a
    // baixa automatica ao concluir a OS nao trava mais em zero); esse caso
    // precisa de destaque proprio, mais forte que "zerado".
    if (item.quantidade < 0) return { label:t("estoque.status_negativo", "Estoque negativo"), cor:"#dc2626", bg:"#dc262633" };
    if (item.quantidade === 0) return { label:t("estoque.status_zerado"), cor:"#ef4444", bg:"#ef444422" };
    if (item.quantidade <= item.minimo) return { label:t("estoque.status_baixo"), cor:"#f97316", bg:"#f9731622" };
    return { label:t("estoque.status_normal"), cor:"#22c55e", bg:"#22c55e22" };
  };

  const formVazio = { nome:"", categoria:"Filtros", quantidade:"", minimo:"", preco:"", custo:"", unidade:"un", codigo:"", foto:"" };

  return (
    <Layout>
      <style>{`@keyframes spin { from { transform:rotate(0deg); } to { transform:rotate(360deg); } }`}</style>
      <div style={{ display:"flex", flexDirection:"column", gap:20 }}>

        <div style={{ alignItems:"flex-start", display:"flex", justifyContent:"space-between" }}>
          <div>
            <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{ fontSize:22, fontWeight:700 }}>{t("estoque.titulo")}</h1><BotaoDica id="estoque" /></div>
            <p style={{ color:"var(--text2)", fontSize:13, marginTop:3 }}>{t(totalItens === 0 ? "estoque.subtitulo_vazio"
               : totalItens === 1 ? "estoque.subtitulo_um"
               : "estoque.subtitulo_count", {count:totalItens})}</p>
          </div>
          <div style={{ display:"flex", gap:8 }}>
            <button className="btn-ghost" onClick={() => setModalBusca(true)} style={{ fontSize:13, padding:"10px 18px" }}>{t("estoque.busca_externa")}</button>
            <button className="btn-ghost" onClick={() => setModalRadar(true)} style={{ fontSize:13, padding:"10px 18px" }}>{t("estoque.radar_abrir")}</button>
            <button className="btn-primary" onClick={() => { setModalEditar(null); setForm(formVazio); setModalNovo(true); }} style={{ fontSize:13, padding:"10px 18px" }}>{t("estoque.novo_item")}</button>
          </div>
        </div>

        <Dica id="estoque" jaUsou={totalItens > 0} texto={t("dicas.estoque")} />

        <div style={{ display:"grid", gap:16, gridTemplateColumns:"repeat(4,1fr)" }}>
          {[
            { label:t("estoque.total_itens"),   valor:totalItens,  cor:"#6366f1" },
            { label:t("estoque.estoque_baixo"),    valor:estoqueBaixo, cor:estoqueBaixo>0?"#f97316":"#22c55e" },
            { label:t("estoque.valor_estoque"), valor:"R$ "+valorTotal.toLocaleString("pt-BR",{minimumFractionDigits:2}), cor:"#22c55e" },
            { label:t("estoque.lucro_potencial"),  valor:"R$ "+lucroTotal.toLocaleString("pt-BR",{minimumFractionDigits:2}), cor:"#a78bfa" },
          ].map(c => (
            <div key={c.label} className="card" style={{ borderTop:"3px solid "+c.cor }}>
              <div style={{ color:"var(--text2)", fontSize:11, fontWeight:600, letterSpacing:"0.07em", marginBottom:8, textTransform:"uppercase" }}>{c.label}</div>
              <div style={{ color:c.cor, fontSize:24, fontWeight:800 }}>{c.valor}</div>
            </div>
          ))}
        </div>

        <div style={{ alignItems:"center", display:"flex", flexWrap:"wrap", gap:10 }}>
          <input value={busca} onChange={e => setBusca(e.target.value)} placeholder={t("estoque.buscar_placeholder")} style={{ flex:1, maxWidth:360 }} />
          <select value={categoria} onChange={e => setCategoria(e.target.value)} style={{ minWidth:180 }}>
            <option value="Todas">{t("estoque.todas_categorias")}</option>
            {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>

        <div style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:"var(--radius)", overflow:"auto" }}>
          <table style={{ borderCollapse:"collapse", minWidth:1000, width:"100%" }}>
            <thead>
              <tr style={{ background:"var(--bg4)" }}>
                {[t("estoque.col_foto"),t("estoque.col_codigo"),t("estoque.col_nome"),t("estoque.col_categoria"),t("estoque.col_qtd"),t("estoque.col_min"),t("estoque.col_custo"),t("estoque.col_preco_venda"),t("estoque.col_margem"),t("estoque.col_total"),t("estoque.col_status"),t("estoque.col_acoes")].map(h => (
                  <th key={h} style={{ color:"var(--text2)", fontSize:11, fontWeight:600, letterSpacing:"0.07em", padding:"12px 10px", textAlign:"left", textTransform:"uppercase", whiteSpace:"nowrap" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.map(item => {
                const st = statusEstoque(item);
                const { lucroUnit, margem } = calcMargem(item.custo, item.preco);
                return (
                  <tr key={item.id} style={{ borderTop:"1px solid var(--border)" }}
                    onMouseOver={e => e.currentTarget.style.background="var(--bg4)"}
                    onMouseOut={e => e.currentTarget.style.background="transparent"}>
                    <td style={{ padding:"10px 10px" }}>
                      {item.foto
                        ? <img src={item.foto} alt={item.nome} style={{ borderRadius:6, height:36, objectFit:"cover", width:36 }} />
                        : <div style={{ alignItems:"center", background:"var(--bg4)", borderRadius:6, display:"flex", height:36, justifyContent:"center", width:36 }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--text3)" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                          </div>}
                    </td>
                    <td style={{ color:"var(--text3)", fontFamily:"monospace", fontSize:12, padding:"10px 10px" }}>{item.codigo}</td>
                    <td style={{ fontWeight:600, padding:"10px 10px" }}>{item.nome}</td>
                    <td style={{ padding:"10px 10px" }}><span style={{ background:"var(--bg4)", borderRadius:6, color:"var(--text2)", fontSize:11, padding:"2px 7px" }}>{item.categoria}</span></td>
                    <td style={{ padding:"10px 10px" }}>
                      <span style={{ color:item.quantidade<0?"#dc2626":item.quantidade<=item.minimo?"#f97316":"var(--text)", fontWeight:700, fontSize:15 }}>{item.quantidade}</span>
                      {item.quantidade<0&&<span style={{ background:"#dc262622", borderRadius:6, color:"#dc2626", fontSize:10, fontWeight:700, marginLeft:6, padding:"1px 6px" }}>{t("estoque.status_negativo","NEGATIVO")}</span>}
                      <span style={{ color:"var(--text3)", fontSize:10, marginLeft:3 }}>{item.unidade}</span>
                    </td>
                    <td style={{ color:"var(--text2)", fontSize:12, padding:"10px 10px" }}>{item.minimo}</td>
                    <td style={{ color:"#f97316", fontSize:12, padding:"10px 10px" }}>{item.custo?("R$ "+Number(item.custo).toFixed(2)):<span style={{color:"var(--text3)"}}>-</span>}</td>
                    <td style={{ padding:"10px 10px" }}>R$ {item.preco.toFixed(2)}</td>
                    <td style={{ padding:"10px 10px" }}>
                      {item.custo>0
                        ? <div>
                            <span style={{ color:margem>=20?"#22c55e":margem>=10?"#f97316":"#ef4444", fontWeight:700, fontSize:13 }}>{margem.toFixed(1)}%</span>
                            <div style={{ color:"var(--text3)", fontSize:10 }}>+R$ {lucroUnit.toFixed(2)}</div>
                          </div>
                        : <span style={{ color:"var(--text3)", fontSize:11 }}>-</span>}
                    </td>
                    <td style={{ color:"var(--green)", fontWeight:600, padding:"10px 10px" }}>R$ {(item.quantidade*item.preco).toLocaleString("pt-BR",{minimumFractionDigits:2})}</td>
                    <td style={{ padding:"10px 10px" }}><span style={{ background:st.bg, borderRadius:20, color:st.cor, fontSize:11, fontWeight:600, padding:"3px 9px" }}>{st.label}</span></td>
                    <td style={{ padding:"10px 10px" }}>
                      <div style={{ display:"flex", gap:5 }}>
                        <button className="btn-primary" style={{ fontSize:11, padding:"4px 9px" }} onClick={() => { setModalMovimento(item); setTipoMov("entrada"); setQtdMov(""); }}>{t("estoque.mov")}</button>
                        <button className="btn-ghost" style={{ fontSize:11, padding:"4px 9px" }} onClick={() => { setForm({ nome:item.nome, categoria:item.categoria, quantidade:String(item.quantidade), minimo:String(item.minimo), preco:String(item.preco), custo:String(item.custo||""), unidade:item.unidade, codigo:item.codigo, foto:item.foto||"" }); setModalEditar(item); }}>{t("common.editar")}</button>
                        <button style={{ fontSize:11, padding:"4px 9px", background:"#ef444422", border:"1px solid #ef444455", borderRadius:8, color:"#ef4444", cursor:"pointer" }} onClick={() => excluirItem(item)}>{t("common.excluir")}</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {filtrados.length === 0 && <div style={{ color:"var(--text2)", padding:32, textAlign:"center" }}>{t("estoque.nenhum_item")}</div>}
        </div>
      </div>

      {modalBusca && <ModalBuscaExterna onClose={() => setModalBusca(false)} estoqueAtual={itens} onImportar={importarProduto} />}
      {modalRadar && <ModalRadarEstoque onClose={() => setModalRadar(false)} tenantId={tenantId} />}


      {modalRadar && <ModalRadarEstoque onClose={() => setModalRadar(false)} tenantId={tenantId} />}

      {(modalNovo||modalEditar) && (
        <Modal onClose={() => { setModalNovo(false); setModalEditar(null); }} largura={620}>
          <div style={{ alignItems:"center", display:"flex", justifyContent:"space-between", marginBottom:20 }}>
            <h2 style={{ fontSize:18, fontWeight:700 }}>{modalEditar?t("estoque.modal_editar_titulo"):t("estoque.modal_novo_titulo")}</h2>
            <BtnFechar onClick={() => { setModalNovo(false); setModalEditar(null); }} />
          </div>
          <div style={{ display:"grid", gap:14, gridTemplateColumns:"1fr 1fr" }}>
            <div style={{ gridColumn:"1 / -1" }}>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.nome_peca")}</label>
              <input value={form.nome} onChange={e => atualizar("nome",e.target.value)} placeholder={t("estoque.nome_peca_placeholder")} style={{ width:"100%" }} />
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.codigo")}</label>
              <input value={form.codigo} onChange={e => atualizar("codigo",e.target.value.toUpperCase())} placeholder={t("estoque.codigo_placeholder")} style={{ width:"100%" }} />
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.categoria")}</label>
              <select value={form.categoria} onChange={e => atualizar("categoria",e.target.value)} style={{ width:"100%" }}>
                {CATEGORIAS.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.quantidade")}</label>
              <input type="number" value={form.quantidade} onChange={e => atualizar("quantidade",e.target.value)} placeholder="0" style={{ width:"100%" }} />
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.estoque_minimo")}</label>
              <input type="number" value={form.minimo} onChange={e => atualizar("minimo",e.target.value)} placeholder="0" style={{ width:"100%" }} />
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.custo_compra")}</label>
              <input type="number" value={form.custo} onChange={e => atualizar("custo",e.target.value)} placeholder="0.00" style={{ width:"100%", borderColor:"#f97316" }} />
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.preco_venda")}</label>
              <input type="number" value={form.preco} onChange={e => atualizar("preco",e.target.value)} placeholder="0.00" style={{ width:"100%", borderColor:"#22c55e" }} />
            </div>
            <div>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.unidade")}</label>
              <select value={form.unidade} onChange={e => atualizar("unidade",e.target.value)} style={{ width:"100%" }}>
                {["un","lt","jg","cx","kg","mt"].map(u => <option key={u} value={u}>{u}</option>)}
              </select>
            </div>
            <div style={{ gridColumn:"1 / -1" }}>
              <CalculadorPreco custo={form.custo} preco={form.preco} onPrecoSugerido={p => atualizar("preco",p)} />
            </div>
            <div style={{ gridColumn:"1 / -1" }}>
              <label style={{ color:"var(--text2)", display:"block", fontSize:11, fontWeight:600, letterSpacing:"0.06em", marginBottom:5, textTransform:"uppercase" }}>{t("estoque.foto_produto")}</label>
              <div style={{ display:"flex", gap:10, alignItems:"center", marginBottom:8 }}>
                <label style={{ background:"var(--accent)", borderRadius:8, color:"#fff", cursor:"pointer", fontSize:12, fontWeight:600, padding:"8px 14px", whiteSpace:"nowrap" }}>
                  {t("estoque.upload")}
                  <input type="file" accept="image/*" style={{ display:"none" }} onChange={e => {
                    const f = e.target.files[0]; if (!f) return;
                    if (f.size > 300*1024) { alert(t("estoque.max_300kb")); return; }
                    const r = new FileReader(); r.onloadend = () => atualizar("foto",r.result); r.readAsDataURL(f);
                  }} />
                </label>
                <span style={{ color:"var(--text3)", fontSize:12 }}>{t("estoque.ou")}</span>
                <input value={form.foto&&form.foto.startsWith("data:")?"":(form.foto||"")} onChange={e => atualizar("foto",e.target.value)} placeholder={t("estoque.cole_url")} style={{ flex:1 }} />
              </div>
              {form.foto && (
                <div style={{ alignItems:"center", display:"flex", gap:10 }}>
                  <img src={form.foto} alt="preview" style={{ borderRadius:8, height:60, objectFit:"cover", width:60 }} onError={e => e.target.style.display="none"} />
                  <button onClick={() => atualizar("foto","")} style={{ background:"none", border:"1px solid #ef4444", borderRadius:6, color:"#ef4444", cursor:"pointer", fontSize:11, padding:"3px 10px" }}>{t("estoque.remover")}</button>
                </div>
              )}
            </div>
          </div>
          <div style={{ display:"flex", gap:10, justifyContent:"flex-end", marginTop:20 }}>
            <button className="btn-ghost" onClick={() => { setModalNovo(false); setModalEditar(null); }}>{t("common.cancelar")}</button>
            <button className="btn-primary" onClick={salvar}>{modalEditar?t("common.salvar"):t("estoque.cadastrar")}</button>
          </div>
        </Modal>
      )}

      {modalMovimento && (
        <Modal onClose={() => setModalMovimento(null)} largura={440}>
          <div style={{ alignItems:"center", display:"flex", justifyContent:"space-between", marginBottom:20 }}>
            <div>
              <div style={{ color:"var(--text2)", fontSize:12, marginBottom:4 }}>{t("estoque.movimentacao")}</div>
              <div style={{ fontSize:18, fontWeight:700 }}>{modalMovimento.nome}</div>
            </div>
            <BtnFechar onClick={() => setModalMovimento(null)} />
          </div>
          <div style={{ background:"var(--bg3)", borderRadius:10, marginBottom:20, padding:16, textAlign:"center" }}>
            <div style={{ color:"var(--text2)", fontSize:12, marginBottom:4 }}>{t("estoque.quantidade_atual")}</div>
            <div style={{ color:modalMovimento.quantidade<=modalMovimento.minimo?"#f97316":"var(--green)", fontSize:36, fontWeight:800 }}>
              {modalMovimento.quantidade} <span style={{ fontSize:16, fontWeight:400 }}>{modalMovimento.unidade}</span>
            </div>
          </div>
          <div style={{ display:"flex", gap:8, marginBottom:16 }}>
            {[{tipo:"entrada",cor:"#22c55e"},{tipo:"saida",cor:"#ef4444"}].map(mv => (
              <button key={mv.tipo} onClick={() => setTipoMov(mv.tipo)} style={{ background:tipoMov===mv.tipo?mv.cor+"22":"var(--bg3)", border:"2px solid "+(tipoMov===mv.tipo?mv.cor:"var(--border)"), borderRadius:8, color:tipoMov===mv.tipo?mv.cor:"var(--text2)", cursor:"pointer", flex:1, fontSize:14, fontWeight:tipoMov===mv.tipo?700:400, padding:"10px" }}>
                {mv.tipo==="entrada"?t("estoque.entrada"):t("estoque.saida")}
              </button>
            ))}
          </div>
          <input type="number" value={qtdMov} onChange={e => setQtdMov(e.target.value)} placeholder={t("estoque.quantidade_placeholder")} style={{ fontSize:24, fontWeight:700, marginBottom:16, textAlign:"center", width:"100%" }} />
          <div style={{ display:"flex", gap:10 }}>
            <button className="btn-ghost" onClick={() => setModalMovimento(null)} style={{ flex:1 }}>{t("common.cancelar")}</button>
            <button onClick={registrarMovimento} style={{ background:tipoMov==="entrada"?"var(--green)":"#ef4444", border:"none", borderRadius:"var(--radius)", color:"#fff", cursor:"pointer", flex:1, fontFamily:"inherit", fontSize:14, fontWeight:700, padding:12 }}>
              {t("common.confirmar")}
            </button>
          </div>
        </Modal>
      )}
    </Layout>
  );
}
